module.exports = "<div *ngIf=\"video\">\n  <h3>{{video.title}}</h3>\n  <div class=\"vimeo-iframe-wrapper\">\n    <iframe [src]=\"videoUrl()\" frameborder=\"0\" title=\"{{video.title}}\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n  </div>\n</div>\n<!-- <hr> -->"


//////////////////
// WEBPACK FOOTER
// /Users/mdg/Source/markclimb/src/app/vimeo/vimeo-player.component.html
// module id = ../../../../../src/app/vimeo/vimeo-player.component.html
// module chunks = main